// see https://developers.google.com/web/updates/2015/01/ES6-Template-Strings

const reEscape = /[&<>'"]/g;
const reUnescape = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34);/g;
const oEscape = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  "'": '&#39;',
  '"': '&quot;'
};
const oUnescape = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"'
};
const replace = String.prototype.replace;

function fnEscape(m) {
  return oEscape[m];
}

function fnUnescape(m) {
  return oUnescape[m];
}

export function escape(s) {
  return replace.call(s, reEscape, fnEscape);
}
export function unescape(s) {
  return replace.call(s, reUnescape, fnUnescape);
}
